<template>
  <Modal v-model="modal" :title="form.bankCardId?$t('title.w28'):$t('title.w29')" :mask-closable="false">
    <div>
      <Form label-position="top" :model="form" ref="form" :rules="formRule">
        <FormItem :label="$t('label.w46')" class="realName">
          <div class="name">{{$store.state.user.info.RealName}}</div>
        </FormItem>
        <FormItem :label="$t('label.w47')">
          <Select v-model="form.bankId">
            <Option
              v-for="v in cardlist"
              :key="v.Id"
              :value="v.Id"
            >{{v.Name}}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('label.w48')">
          <AreaSelector :default-value="areaDefault" @change="areaChange" v-if="modal"/>
        </FormItem>
        <FormItem label="开户支行" prop="branchName">
          <Input :placeholder="$t('pl.p26')" v-model="form.branchName"/>
        </FormItem>
        <FormItem label="银行卡号" prop="cardNumber">
          <Input :placeholder="$t('pl.p27')" v-model="form.cardNumber"/>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button type="primary" :disabled="form.branchName==''||form.cardNumber==''||form.regionId==''||form.bankId==''" @click="submit">{{$t('btn.b46')}}</Button>
    </template>
  </Modal>
</template>

<script>
import formRule from '@/libs/formRule'
import AreaSelector from '@/components/areaSelector'
import {getOnce} from '@/libs/axios'
export default {
  components:{AreaSelector},
  data() {
    return {
      areaDefault:null,
      cardlist:[],
      form: {
        bankCardId:'',
        bankId:'',
        regionId:'',
        branchName:'',
        cardNumber:'',
      },
      formRule: {
        branchName: [
          { required: true, message: this.$t('msg.m39'), trigger: "submit" }
        ],
        cardNumber:formRule.cardNumber
      },
      modal: false
    };
  },
  methods: {
    async submit() {
      // 提交前验证表单
      let valid = await this.$refs.form.validate();
      if (!valid) return;

      let res = await this.$axios.post("/Member/RZJFund/EditBankCard", this.form);
      if (res.err) return res.throw();
      this.$Message.success(this.form.bankCardId?this.$t('msg.m40'):this.$t('msg.m41'));
      this.$emit('done');
      this.modal = false;
    },
    reset(){
      this.areaDefault=null
      this.$refs.form.resetFields();
    },
    async getBankList(){
      let res=await getOnce('/Member/RZJFund/BankList');
      if(res.err) return;
      this.cardlist=res
    },
    areaChange(v){
      this.form.regionId=v
    },
    async load(id){
      this.form.bankCardId=id;
      let res=await this.$axios.get('/Member/RZJFund/BankCardDetail',{params:{bankCardId:id}});
      if(res.err) return;
      this.form.bankId=res.BankId.toString()
      this.form.regionId=res.RegionId
      this.form.branchName=res.BranchName
      this.form.cardNumber=res.CardNumber
      this.areaDefault=res.Region.map(v=>v.Id)
      this.modal=true
    }
  },
  mounted(){
    this.getBankList()
  },
  watch:{
    modal(v){
      if(!v) this.reset();
    }
  },
  computed: {
    
  }
};
</script>
<style lang="less" scoped>
.realName{
  position: relative;
  .name{
    position: absolute;
    left: 77px;
    top:-30px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
}
</style>

